import { LoadedDocument } from '../../model/LoadedDocument';
import { useLoadedDocumentHandle } from './useLoadedDocumentHandle';

/**
 * Subscribes to the {@link ContentEditorService} and returns the loaded
 * document snapshot (draft, finalizing, or publication). Returns undefined
 * while no document is loaded. Re-subscribes when the service instance changes.
 *
 * Prefer {@link useContent} when only the editable content body is needed; use
 * this when the document `kind` or publication-only fields (attachments,
 * publication date) matter.
 */
export function useLoadedDocument(): LoadedDocument | undefined {
  return useLoadedDocumentHandle()?.document;
}
